<div style="margin-bottom: 20px; display: flex; gap: 20px;">
    <div class="form-group" style="width: 400px;">
        <label for="exportFilename">Filename</label>
        <input type="text" id="exportFilename" name="exportFilename" class="form-control" [(ngModel)]="exportDataCriteria.filename" style="height: 35px;" required>
    </div>
    <div>
        <button type="button" class="btn btn-info" (click)="exportDataWithOptions()" style="margin-top: 22px">Export</button>
    </div>
</div>
<div style="margin-bottom: 10px; display: flex; gap: 12px;">
    <label style="margin-right: 10px;" for="saveAs">Save As:</label>
    <!-- <input type="radio" [(ngModel)]="exportDataCriteria.saveAs" name="saveAs" value="CSV" style="margin-top: 0px;" />
    <label style="margin-right: 10px;">CSV (Format A)</label> -->
    <input type="radio" [(ngModel)]="exportDataCriteria.saveAs" name="saveAs" value="CSV2" style="margin-top: 0px;" />
    <label style="margin-right: 10px;">CSV</label>
    <input type="radio" [(ngModel)]="exportDataCriteria.saveAs" name="saveAs" value="JSON" style="margin-top: 0px;" />
    <label style="margin-right: 10px;">JSON</label>
</div>

  <hr>
  <label style="margin-bottom: 15px;">Options </label>

  <div style="margin-bottom: 15px; display: flex; gap: 12px;">
    <input type="radio" [(ngModel)]="exportDataCriteria.interpolateData" name="interpolateData" [value]=false style="margin-top: 0px;" />
    <label>Use original time stamped data (no interpolation)</label>
  </div>

  <div style="margin-bottom: 10px; display: flex; gap: 12px;">
    <input type="radio" [(ngModel)]="exportDataCriteria.interpolateData" name="interpolateData" [value]=true style="margin-top: 0px;" />
    <label>Interpolate data before exporting</label>
  </div>

  <div style="margin-bottom: 10px; margin-left: 26px; display: flex; gap: 12px;">
    <label for="interval">Interval:</label>
    <input type="radio" [(ngModel)]="exportDataCriteria.interpolateInterval" name="interpolateInterval" value="15 Min" style="margin-top: 0px;" (click)="setInterpolateData(true)" />
    <label style="margin-right: 10px;">15 Min</label>
    <input type="radio" [(ngModel)]="exportDataCriteria.interpolateInterval" name="interpolateInterval" value="30 Min" style="margin-top: 0px;" (click)="setInterpolateData(true)" />
    <label style="margin-right: 10px;">30 Min</label>
    <input type="radio" [(ngModel)]="exportDataCriteria.interpolateInterval" name="interpolateInterval" value="1 Hr" style="margin-top: 0px;" (click)="setInterpolateData(true)" />
    <label style="margin-right: 10px;">1 Hr</label>          
    <input type="radio" [(ngModel)]="exportDataCriteria.interpolateInterval" name="interpolateInterval" value="24 Hrs" style="margin-top: 0px;" (click)="setInterpolateData(true)" />
    <label style="margin-right: 10px;">24 Hrs</label>
  </div>

  <div style="margin-bottom: 20px; margin-left: 26px; display: flex; gap: 12px;">
    <label for="interval">Method:</label>
    <input type="radio" [(ngModel)]="exportDataCriteria.interpolateMethod" name="interpolateMethod" value="Linear" style="margin-top: 0px;" (click)="setInterpolateData(true)" />
    <label style="margin-right: 10px;">Linear</label>
    <input type="radio" [(ngModel)]="exportDataCriteria.interpolateMethod" name="interpolateMethod" value="Spline" style="margin-top: 0px;" disabled=true (click)="setInterpolateData(true)" />
    <label style="margin-right: 10px;">Spline</label>
  </div>

  <div style="margin-bottom: 10px; display: flex; gap: 12px;">
    <input type="checkbox" style="vertical-align: middle;" [(ngModel)]="exportDataCriteria.ignoreOutliers" [ngModelOptions]="{standalone: true}" [checked]="exportDataCriteria.ignoreOutliers" style="margin-top: 5px;" />
    <label>Ignore outlier data</label>
  </div>

  <div style="margin-bottom: 7px; margin-left: 26px; display: flex; gap: 12px;">
    <label>Less than</label>
    <input type="text" style="margin-top: -3px;" [(ngModel)]="exportDataCriteria.ignoreOutliersLessThan" [ngModelOptions]="{standalone: true}"/>
  </div>

  <div style="margin-bottom: 20px; margin-left: 26px; display: flex; gap: 12px;">
    <label>or greater than</label>
    <input type="text" style="margin-top: -3px;" [(ngModel)]="exportDataCriteria.ignoreOutliersGreaterThan" [ngModelOptions]="{standalone: true}"/>
  </div>

  <div style="margin-bottom: 20px; display: flex; gap: 12px;">
    <input type="checkbox" style="vertical-align: middle;" [(ngModel)]="exportDataCriteria.includeGpsInfo" [ngModelOptions]="{standalone: true}"
            [checked]="exportDataCriteria.includeGpsInfo" [disabled]="exportDataCriteria.interpolateData" style="margin-top: 5px;" />
    <label>Include GPS Info</label>
  </div>
